import { useEffect } from "react";
import "@/App.css";
import { BrowserRouter, Routes, Route, useLocation } from "react-router-dom";
import { Toaster } from "sonner";
import { Navbar } from "@/components/Navbar";
import { Hero } from "@/components/Hero";
import { Portfolio } from "@/components/Portfolio";
import { Inquiry } from "@/components/Inquiry";
import { Footer } from "@/components/Footer";
import { Leapbodies } from "@/components/Leapbodies";
import { Tee } from "@/components/Tee";
import { Hoodie } from "@/components/Hoodie";
import { MaisonPique } from "@/components/MaisonPique";
import { HyroxFlags } from "@/components/HyroxFlags";
import { PrivateRoute } from "@/components/admin/PrivateRoute";
import { AuthProvider } from "@/context/AuthContext";
import { AdminLogin } from "@/components/admin/AdminLogin";
import { AdminDashboard } from "@/components/admin/AdminDashboard";

export const scrollToSection = (hash) => {
  document.querySelector(hash)?.scrollIntoView({ behavior: "smooth" });
};

const ScrollToTop = () => {
  const { pathname, hash } = useLocation();
  useEffect(() => {
    if (hash) {
      setTimeout(() => scrollToSection(hash), 50);
    } else {
      window.scrollTo(0, 0);
    }
  }, [pathname, hash]);
  return null;
};

const Home = () => (
  <>
    <Navbar />
    <main>
      <Hero />
      <Portfolio />
      <Inquiry />
    </main>
    <Footer />
  </>
);

export default function App() {
  return (
    <div
      className="bg-parchment text-ink font-sans antialiased"
      data-testid="app-root"
    >
      <BrowserRouter>
        <AuthProvider>
          <ScrollToTop />
          <Routes>
            <Route path="/" element={<Home />} />
            <Route path="/leapbodies" element={<Leapbodies />} />
            <Route path="/leapbodies/tee" element={<Tee />} />
            <Route path="/leapbodies/hoodie" element={<Hoodie />} />
            <Route path="/maison-pique" element={<MaisonPique />} />
            <Route
              path="/hyrox-flags"
              element={
                <PrivateRoute>
                  <HyroxFlags />
                </PrivateRoute>
              }
            />
            <Route path="/admin/login" element={<AdminLogin />} />
            <Route path="/admin" element={<AdminDashboard />} />
          </Routes>
        </AuthProvider>
      </BrowserRouter>
      <Toaster position="bottom-right" />
    </div>
  );
}
